import { isError } from 'lib/isError';
import React from 'react';
import {
  ErrorBoundary as RNErrorBoundary,
  FallbackProps,
} from 'react-error-boundary';
import { View } from 'react-native';
import { useDispatch } from 'react-redux';
import { CATCH_ERROR } from 'store/error/actions';

type ErrorBoundaryProps = {
  FallbackComponent?: React.ComponentType<FallbackProps>;
  onError?: (
    error: Error,
    info: {
      componentStack: string;
    },
  ) => void;
  children: React.ReactNode;
};

export const ErrorBoundary: React.FC<ErrorBoundaryProps> = ({
  children,
  FallbackComponent,
  onError,
}) => {
  const dispatch = useDispatch();
  const props = FallbackComponent
    ? { FallbackComponent }
    : { fallback: <View /> };
  return (
    <RNErrorBoundary
      {...props}
      onError={(error, info) => {
        dispatch(
          CATCH_ERROR({ error, info: { componentStack: info.componentStack } }),
        );
        if (isError(error)) {
          onError?.(error, { componentStack: info.componentStack ?? '' });
        }
      }}
    >
      {children}
    </RNErrorBoundary>
  );
};
